import { createFileRoute, redirect } from "@tanstack/react-router";

// Los clientes pasaron a ser una sección de nivel superior (/clients).
// Mantener esta ruta como redirect para enlaces antiguos.
export const Route = createFileRoute("/_auth/media/clients")({
  beforeLoad: () => {
    throw redirect({ to: "/clients" });
  },
});
